// @ts-nocheck
import { ApiParameter, post } from "@insite/client-framework/Services/ApiService";
import { AskForQuoteModel } from "@store/Framework/Types/ApiModels";

const emailsUrl = "/api/v1/custom";

export interface AskForQuoteApiParameter extends ApiParameter {
    askForQuoteModel: AskForQuoteModel;
}

export function postAskForQuote(parameter: AskForQuoteApiParameter) {
    return post<AskForQuoteModel>(`${emailsUrl}/quotes`, parameter.askForQuoteModel);
}
